import { useContext } from "react";
import SessionContext from "../Contexts/SessionContext";

const useSession = () => useContext(SessionContext);

export default useSession;
